import { getClientTimezoneValue } from '../../../helpers/timezone/TimezoneHelper';

export const WEEK_LENGTH = 7;
export const YEAR_LENGTH_IN_WEEKS = 52;
export const USER_TIMEZONE_VALUE = getClientTimezoneValue();
